class SiteHeader {
  constructor(el) {
    this.el = el;
    this.headerHeight = 0;
    this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
    this.megaMenuBg = document.querySelector('.site-header__megamenu-bg');

    this.updateHeaderHeightVar();
    this.setupEventHandlers();
    this.removeSearchValue();
  }

  setupEventHandlers() {
    const body = document.body;
    const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

    if (btnMobileMenu) {
      btnMobileMenu.addEventListener('click', () => {
        document.documentElement.classList.toggle('mobile-menu-active');
      });
    }

    // ✅ Manejo de los toggles sin bloquear los links
    const toggles = this.el.querySelectorAll('.site-header__mobile-menu--primary .mobile-top-level-link .plus-minus');

    toggles.forEach((tg) => {
      tg.addEventListener('click', (e) => {
        e.stopPropagation(); // evita burbuja pero no interfiere con los links
        const row = tg.closest('.mobile-top-level-link');
        const submenu = row.nextElementSibling;
        const isOpen = row.classList.contains('active');

        // cerrar los demás
        this.el.querySelectorAll('.mobile-top-level-link.active').forEach((r) => {
          if (r !== row) {
            r.classList.remove('active');
            const sm = r.nextElementSibling;
            if (sm && sm.classList.contains('mobile-menu-sub-menu')) sm.style.maxHeight = 0;
          }
        });

        // abrir el actual
        if (!isOpen) {
          row.classList.add('active');
          if (submenu && submenu.classList.contains('mobile-menu-sub-menu')) {
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
          }
        } else {
          row.classList.remove('active');
          if (submenu && submenu.classList.contains('mobile-menu-sub-menu')) {
            submenu.style.maxHeight = 0;
          }
        }
      });
    });

    // ✅ asegúrate de permitir navegación normal en los <a>
    const topLinks = this.el.querySelectorAll('.site-header__mobile-menu--primary .mobile-top-level-link-text');
    topLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.stopPropagation(); // no bloquea navegación
        // no usamos preventDefault — el link funciona normal
      });
    });

    // actualizar header en scroll/resize
    window.addEventListener('resize', () => this.updateHeaderHeightVar());
    window.addEventListener('scroll', () => this.updateHeaderHeightVar());

    // manejo de mega menú desktop
    if (this.megaMenuLinks) {
      this.megaMenuLinks.forEach((link) => {
        link.addEventListener('click', () => {
          this.megaMenuLinks.forEach((m) => {
            if (m !== link) {
              m.setAttribute('aria-expanded', false);
              m.classList.remove('active');
            }
          });

          if (link.classList.contains('active')) {
            body.classList.remove('no-scroll');
            link.setAttribute('aria-expanded', false);
            link.classList.remove('active');
            if (this.megaMenuBg) this.megaMenuBg.classList.remove('active');
          } else {
            body.classList.add('no-scroll');
            link.setAttribute('aria-expanded', true);
            link.classList.add('active');
            if (this.megaMenuBg) this.megaMenuBg.classList.add('active');
          }
        });
      });
    }

    if (this.megaMenuBg) {
      this.megaMenuBg.addEventListener('click', () => {
        this.megaMenuBg.classList.remove('active');
        body.classList.remove('no-scroll');
        this.megaMenuLinks.forEach((m) => {
          m.setAttribute('aria-expanded', false);
          m.classList.remove('active');
        });
      });
    }

    document.addEventListener('keydown', (evt) => {
      if (evt.key === 'Escape') {
        this.megaMenuLinks.forEach((m) => m.classList.remove('active'));
        body.classList.remove('no-scroll');
        if (this.megaMenuBg) this.megaMenuBg.classList.remove('active');
      }
    });
  }

  updateHeaderHeightVar() {
    this.headerHeight = this.el.offsetHeight;
  }

  removeSearchValue() {
    const searchInput = document.getElementById('searchsubmitmobile');
    if (searchInput) searchInput.value = '';
  }
}

export default SiteHeader;
